import { SamplesRequestModalSource } from "@faire/deprecated-retailer-visitor-shared/components/Modals/SamplesRequestModal/types";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";

const DEFAULT_DISPLAY_PAGE_TYPE = undefined;

export const getSamplesRequestModalSourceFromDisplayPageType = (
  displayPageType: keyof typeof DisplayPageType | undefined
): SamplesRequestModalSource | undefined => {
  if (displayPageType === undefined) {
    return DEFAULT_DISPLAY_PAGE_TYPE;
  }
  return (
    samplesRequestModalSourceFromDisplayPageTypeMap[displayPageType] ??
    DEFAULT_DISPLAY_PAGE_TYPE
  );
};

const samplesRequestModalSourceFromDisplayPageTypeMap: Partial<
  Record<DisplayPageType, SamplesRequestModalSource>
> = {
  [DisplayPageType.DISPLAY_PAGE_TYPE_UNKNOWN]: DEFAULT_DISPLAY_PAGE_TYPE,
  [DisplayPageType.HOMEPAGE]: "HOME",
  [DisplayPageType.CATEGORY_PAGE]: "C1",
};
